import { NavigationTabs, type NavigationTabItem } from '@exam-center/components';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { PageHeader } from '@shared/components';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

const TAB_ITEMS: NavigationTabItem[] = [
  {
    value: 'Events Overview',
    label: 'ภาพรวมตารางสอบ',
    path: '/:examCenterCode/exam-events',
    requiredPermission: [
      APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAM_EVENT.VIEW,
      APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAMINEES.VIEW,
      APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.RESULTS.VIEW,
    ],
  },
  {
    value: 'Activity Log',
    label: 'Activity Log',
    path: '/:examCenterCode/exam-events/activity-log',
    requiredPermission: [APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.AUDIT_LOG.VIEW],
  },
];

export default function ExamEventHeader() {
  const { permissions } = usePermission();

  const filteredItems = useMemo(
    () =>
      TAB_ITEMS.filter(({ requiredPermission }) => {
        if (!requiredPermission || requiredPermission.length === 0) return true;
        return requiredPermission.some((permission) => permissions.includes(permission));
      }),
    [permissions],
  );

  return <PageHeader title='จัดการตารางสอบ' tabs={<NavigationTabs items={filteredItems} />} />;
}
